module.exports = __webpack_public_path__ + "src/img/start_pic1.jpg?58c282f27dd10230ca16fda6dbc8c5e0";


//////////////////
// WEBPACK FOOTER
// ./src/img/start_pic1.jpg
// module id = 199
// module chunks = 0